import React from "react";
import { Link } from "react-router-dom";
import StatusColumn from "widgets/grid/cells/StatusColumn";
import AssignedCreativeEnableUpdate from "./AssignedCreativeEnableUpdate";
import LastUpdatedCell from "widgets/grid/cells/ContentFeeds/LastUpdatedCell";

const CREATIVE_NAME_COLUMN = {
	key: "filename",
	name: "Creative Name",
	width: 220,
	formatter: ({ value, dependentValues }) => {
		if (!dependentValues) {
			return value;
		}
		const { idCreative, libraryId, contentFeedId, contentFeedName } = dependentValues;
		if (!idCreative || !libraryId) {
			return value;
		}
		return (
			<Link
				to={{
					pathname: `/library/${libraryId}/content-feeds/modal/preview-creative/basic/${idCreative}/`,
					state: {
						contentFeedId,
						contentFeedName,
						returnPath: `/library/${libraryId}/content-feeds/modal/assigned-creatives/${contentFeedId}/`,
					},
				}}
				className="creative-name-link"
			>
				{value}
			</Link>
		);
	},
	getRowMetaData: data => data,
};

const CREATIVE_ID_COLUMN = {
	key: "idCreative",
	name: "ID",
	width: 90,
	cellClass: "centered",
};

const CREATIVE_STATUS_COLUMN = {
	key: "approval",
	name: "Status",
	width: 130,
	cellClass: "centered",
	formatter: StatusColumn,
	getRowMetaData: () => ({}),
};

const ENABLE_UPDATES_COLUMN = {
	key: "enableUpdate",
	name: "Enable updates",
	width: 130,
	cellClass: "centered",
	formatter: AssignedCreativeEnableUpdate,
	getRowMetaData: data => data,
};

const LAST_UPDATE_COLUMN = {
	key: "dateLastUpdate",
	name: "Last Update",
	width: 160,
	formatter: LastUpdatedCell,
	getRowMetaData: data => data,
};

export const ASSIGNED_CREATIVES_COLUMNS = [
	CREATIVE_NAME_COLUMN,
	CREATIVE_ID_COLUMN,
	CREATIVE_STATUS_COLUMN,
	ENABLE_UPDATES_COLUMN,
	LAST_UPDATE_COLUMN,
];

